import {Button, Modal, Typography} from '@logistics-frontend/blocks'
import React, {useState} from 'react'

import {ActionOpenLinkToRoute, Dialog} from 'src/api/types'
import {tagToUrl} from 'src/shared/utils'

import {classes} from '../support-button/SupportButton.classes'

type Props = {
  action: ActionOpenLinkToRoute
  dialog: Dialog
}

export function UniversalDialog({action, dialog}: Props): React.ReactElement {
  const [opened, setOpened] = useState<boolean>(false)
  const openHandler = () => setOpened(true)
  const closeHandler = () => setOpened(false)

  return (
    <>
      <button
        className={classes.action}
        onClick={openHandler}
        style={{backgroundImage: `url("${tagToUrl(action.image_tag)}")`}}
      />
      <Typography color="minor" justifyContent="center" variant="caption1">
        {action.title}
      </Typography>
      <Modal mx="m" onClose={closeHandler} opened={opened}>
        <Modal.Header title={dialog.title} />
        {dialog.body && (
          <Modal.Body>
            <Typography variant="body2">{dialog.body}</Typography>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Modal.Footer.Controls>
            <Button onPress={closeHandler} size="l">
              {dialog.close_button?.title || 'Нет, спасибо'}
            </Button>
            <Button Component="a" href={action.url} onPress={closeHandler} size="l" target="_blank" variant="action">
              {dialog.confirm_button?.title || 'Да, конечно'}
            </Button>
          </Modal.Footer.Controls>
        </Modal.Footer>
      </Modal>
    </>
  )
}
